import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { Package } from '../models/package';
import { Order } from '../models/order';
import 'rxjs/add/operator/map';

@Injectable()
export class PaymentService {

  private packageUrl: string = `${ environment.apiRoot }/package/`;
  private transactionUrl: string = `${ environment.apiRoot }/transaction/`;
  private orderUrl: string = `${ environment.apiRoot }/order/`;

  constructor(private http: HttpAuth) { }

  public getPackages(page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.packageUrl, options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  public getTransaction(page?: number, pagecount?: number, status?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (status != null) {
      params.append('status', String(status));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.transactionUrl, options)
        .map(this.extractData)
        .catch(this.handleError);
  }

public getOrders(page?: number, pagecount?: number, status?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if (status != null) {
      params.append('status', String(status));
    }

    const options = new RequestOptions({search: params});

    return this.http.get(this.orderUrl, options)
        .map(this.extractData)
        .catch(this.handleError);
  }

  public postOrder(order): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = order;

    let options = new RequestOptions({search: params});

    return this.http.post(this.orderUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/payment.service.ts